var jade = require("/home/runner/work/banquetNinja/banquetNinja/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div flex=\"flex\" layout=\"column\"><div flex=\"flex\" layout=\"row\"><div flex=\"33\" class=\"form-group\"><label for=\"title\" class=\"control-label\">Rental Item Name</label><input ng-model=\"vm.docSvc.doc.name\" class=\"form-control\"/></div><div flex=\"66\" class=\"form-group\"><label for=\"description\" class=\"control-label\">Description</label><input ng-model=\"vm.docSvc.doc.description\" class=\"form-control\"/></div></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/features/events/rentalitems/tabs/top-panel.jade
// module id = 290
// module chunks = 0